// import PropTypes from 'prop-types';
// import React from "react";

// import { Route, Switch ,BrowserRouter} from "react-router-dom";
// import { connect } from "react-redux";

// // Import Routes all
// import { userRoutes, authRoutes } from "./routes/allRoutes";

// // Import all middleware
// import Authmiddleware from "./routes/middleware/Authmiddleware";

// // layouts Format
// import VerticalLayout from "./components/VerticalLayout/";
// import HorizontalLayout from "./components/HorizontalLayout/";
// import NonAuthLayout from "./components/NonAuthLayout";

// // Import scss
// import "./assets/scss/theme.scss";

// // Import Firebase Configuration file
// // import { initFirebaseBackend } from "./helpers/firebase_helper"

// // Import Fack Backend
// import fakeBackend from "./helpers/AuthType/fakeBackend";

// // Activating fake backend
// fakeBackend();

// // const firebaseConfig = {
// //   apiKey: process.env.REACT_APP_APIKEY,
// //   authDomain: process.env.REACT_APP_AUTHDOMAIN,
// //   databaseURL: process.env.REACT_APP_DATABASEURL,
// //   projectId: process.env.REACT_APP_PROJECTID,
// //   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
// //   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
// //   appId: process.env.REACT_APP_APPID,
// //   measurementId: process.env.REACT_APP_MEASUREMENTID,
// // }

// // init firebase backend
// // initFirebaseBackend(firebaseConfig)

// const App = props => {
//   function getLayout() {
//     let layoutCls = VerticalLayout;

//     switch (props.layout.layoutType) {
//       case "horizontal":
//         layoutCls = HorizontalLayout;
//         break;
//       default:
//         layoutCls = VerticalLayout;
//         break;
//     }
//     return layoutCls;
//   }

//   const getBasename = () => {
//     return `/${process.env.PUBLIC_URL.split('/').pop()}`;
//   };

//   const Layout = getLayout();

//   return (
//     <React.Fragment>
//       <BrowserRouter basename={getBasename()}>
     
//       <Switch>
//         <Route>
//           {authRoutes.map((route, idx) => (
//             <Authmiddleware
//               path={route.path}
//               layout={NonAuthLayout}
//               component={route.component}
//               key={idx}
//               isAuthProtected={false}
//             />
//           ))}

//           {userRoutes.map((route, idx) => (
//             <Authmiddleware
//               path={route.path}
//               layout={Layout}
//               component={route.component}
//               key={idx}
//               isAuthProtected={true}
//               exact
//             />
//           ))}
//         </Route>
//       </Switch>
//       </BrowserRouter>
//     </React.Fragment>
//   );
// };

// App.propTypes = {
//   layout: PropTypes.any
// };

// const mapStateToProps = state => {
//   return {
//     layout: state.Layout,
//   };
// };

// export default connect(mapStateToProps, null)(App);

import PropTypes from 'prop-types';
import React from "react";

import { Route, Switch ,BrowserRouter,Redirect} from "react-router-dom";
import { connect } from "react-redux";

// Import Routes all
import { userRoutes, authRoutes } from "./routes/allRoutes";

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

// Import Fack Backend
import fakeBackend from "./helpers/AuthType/fakeBackend";

import PrivateRoutes from './routes/PrivateRoutes';
import './Login.css'

// Activating fake backend
fakeBackend();

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// }

// init firebase backend
// initFirebaseBackend(firebaseConfig)

const App = props => {
  function getLayout() {
    let layoutCls = VerticalLayout;

    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  const getBasename = () => {
    return `/${process.env.PUBLIC_URL.split('/').pop()}`;
  };

  const Layout = getLayout();

  return (
    <React.StrictMode>
    <BrowserRouter basename={getBasename()} >
    

    
      <Switch>
        
        {authRoutes.map((route, idx) => (
          <Authmiddleware
            path={route.path}
            layout={NonAuthLayout}
            component={route.component}
            key={idx}
            isAuthProtected={false}
          />
        ))}
    </Switch>
    <Route element={<PrivateRoutes />} >

      <Switch>
          {userRoutes.map((route, idx) => (
                  <Authmiddleware
                    path={route.path}
                    layout={Layout}
                    component={route.component}
                    key={idx}
                    isAuthProtected={false}
                    exact
                  />
                  ))} 
      </Switch>   
        <Route>
        {localStorage.getItem('isAuthUser') === 'false' ? (
      
        <Redirect to={{ pathname: "/login"}} />
    
        ): null}
        </Route>
         

    </Route>
   


    </BrowserRouter>
  </React.StrictMode>
  );
};

App.propTypes = {
  layout: PropTypes.any
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);